<template>
  <div class="container-fluid p-0 m-0 bg-amandine" id="app">

  <nav class="sticky-top navbar navbar-expand-lg navbar-light bg-white p-4">

    <router-link to="/" class="navbar-brand pl-2 logo d-none d-md-block"> Christina Basdekidi</router-link>
    <router-link to="/" class="navbar-brand pl-2 logo d-block d-md-none mx-auto">Christina Basdekidi</router-link>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto pr-2">
        <li class="nav-item active mr-3">
          <router-link to="/" class="nav-link">Work</router-link> <span class="sr-only">(current)</span>
        </li>
        <li class="nav-item">
          <router-link to="/contact" class="nav-link">Contact</router-link>
        </li>
        <!--
        <li class="nav-item mr-3">
          <router-link class="nav-link" to="#contact" @click.native="scrollFix('#contact')">Contact</router-link>
        </li>
        -->
      </ul>
    </div>

  </nav>

    <router-view/>
  </div>
</template>

<style>

@import '../public/fonts/style.css';

#app {
  font-family: 'Proxima Nova Regular',Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  letter-spacing: 0.1rem;
  font-size:1rem;
  text-transform: lowercase;
}
.logo {
  width:185px;
}
.bg-amandine{
  background-color: #fcfcfc !important;
}
</style>
<script>
export default {
  name: 'app',
  mounted: function()
  {
    // From testing, without a brief timeout, it won't work.
    //setTimeout(() => this.scrollFix(this.$route.hash), 1)
  },
  methods: {
    scrollFix: function(hashbang)
    {
      location.href = hashbang;
    }
  }
}
</script>1